<template>
  <v-card class="pa-3">
    <v-form ref="form" v-model="valid">
      <v-card-title>
        User Profile
      </v-card-title>
      <v-card-subtitle>
        Add a new CoreCounts profile
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.firstName"
              label="First name"
              maxlength="50"
              :rules="[$rules.required]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.lastName"
              label="Last name"
              maxlength="50"
              :rules="[$rules.required]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.jobTitle"
              label="Job title"
              maxlength="50"
              :rules="[$rules.required]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.phoneNumber"
              label="Phone"
              :rules="[$rules.required, $rules.phone]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.email"
              label="Email"
              maxlength="100"
              :rules="[$rules.required, $rules.email]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.primaryContact.password"
              label="Initial Password"
              outlined
              maxlength="50"
              :rules="[$rules.required, $rules.password]"
              required
              type="password"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-title>
        Company Profile
      </v-card-title>
      <v-card-subtitle>
        Share some info about the company to help us learn more about them.
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="customer.name"
              label="Company name"
              maxlength="50"
              :rules="[$rules.required]"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="customer.industryId"
              :items="industries"
              label="Industry"
              item-text="name"
              item-value="id"
              :rules="[$rules.required]"
              required
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="customer.employeeSizeId"
              :items="employeeSizes"
              label="# Of Employees"
              item-text="name"
              item-value="id"
              :rules="[$rules.required]"
              required
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="isSuperAdmin">
            <v-select
              v-model="customer.isPartner"
              label="Partner"
              :items="partnerItems"
              item-text="name"
              item-value="id"
              outlined
              required
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="isSuperAdmin">
            <v-select
              v-model="customer.planTypeId"
              label="Plan Type"
              :items="company_plan_types"
              item-text="name"
              item-value="id"
              outlined
              required
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
    <v-card-actions>
      <v-btn @click="save" :loading="saving">Create Account</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CreateCustomerForm",
  data: () => ({
    valid: true,
    saving: false,
    partnerItems: [
      { id: false, name: "No" },
      { id: true, name: "Yes" }
    ]
  }),
  computed: {
    isSuperAdmin() {
      return this.$auth.isSuperAdmin();
    },
    ...mapGetters({
      customer: "customer/customer",
      industries: "lookup/industries",
      employeeSizes: "lookup/employee_sizes",
      company_plan_types: "lookup/company_plan_types"
    })
  },
  created() {},
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("customer/addCustomer", this.customer)
          .then(() => {
            this.$root.$snackbarSuccess("Customer created.");
            this.$emit("save");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving customer."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
